// "type" serbest metindir; bilinmeyen tür gelirse varsayılan ikon kullanılır.
const TYPES = {
  PhotoApproved: { label: "Fotoğraf Onaylandı", icon: "mdi-check-circle-outline", color: "success" },
  PhotoRejected: { label: "Fotoğraf Reddedildi", icon: "mdi-close-circle-outline", color: "error" },
  Announcement: { label: "Duyuru", icon: "mdi-bullhorn-outline", color: "info" },
  CameraObstructed: { label: "Kamera Uyarısı", icon: "mdi-camera-off-outline", color: "warning" },
  PassengerWithoutTariff: { label: "Tarifesiz Yolcu", icon: "mdi-account-alert-outline", color: "warning" },
  PanicButton: { label: "Panik Butonu", icon: "mdi-alarm-light-outline", color: "error" },
};
const DEFAULT_TYPE = { label: "", icon: "mdi-bell-outline", color: "primary" };

export const NOTIFICATION_TYPE_OPTIONS = Object.entries(TYPES).map(([value, t]) => ({ value, title: t.label }));

export const getNotificationMeta = (type) => {
  const meta = TYPES[type];
  return meta ? { ...meta } : { ...DEFAULT_TYPE, label: type || "Bildirim" };
};

export const AUDIENCE_LABELS = { owner: "Araç Sahibi", operator: "Operatör", user: "Kullanıcı" };
export const AUDIENCE_OPTIONS = Object.entries(AUDIENCE_LABELS).map(([value, title]) => ({ value, title }));

// Sunucu JWT'deki rol/kanal bilgisini çözer (istemci seçmez, yalnızca arayüzü yönlendirir)
export const getTokenClaims = (token) => {
  try {
    const payload = String(token || "").split(".")[1];
    if (!payload) return {};
    const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(b64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(json) || {};
  } catch (e) {
    return {};
  }
};

const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const hasRole = (claims, role) => {
  const r = claims.role ?? claims[ROLE_CLAIM];
  return Array.isArray(r) ? r.includes(role) : r === role;
};

export const isOwnerClaims = (claims) =>
  hasRole(claims, "VehicleOwner") && claims.channel === "owner" && !!claims.ownerId;
export const isAdminClaims = (claims) => hasRole(claims, "Admin");
